import api from './api';
import axios from 'axios';

const API_URL = '/api/directories';

const getAuthHeaders = () => {
  const token = sessionStorage.getItem('token');
  return { headers: { Authorization: `Bearer ${token}` } };
};

const getDirectories = () => {
  return api.get(API_URL, getAuthHeaders());
};

const createDirectory = (data) => {
  return api.post(API_URL, data, getAuthHeaders());
};

const uploadFile = (directoryName, data) => {
  return api.post(`${API_URL}/upload/${directoryName}`, data, getAuthHeaders());
};

const getUploadSasUrl = (directoryName, fileName) => {
  return api.post(`${API_URL}/upload-sas/${directoryName}`, { fileName }, getAuthHeaders());
};

const uploadFileDirectlyToBlob = (sasUrl, file) => {
  return axios.put(sasUrl, file, {
    headers: {
      'x-ms-blob-type': 'BlockBlob',
      'Content-Type': file.type || 'application/octet-stream'
    }
  });
};

const getFilesInDirectory = (directoryName) => {
  return api.get(`${API_URL}/${directoryName}/files`, getAuthHeaders());
};

const deleteFile = (directoryName, fileName) => {
  return api.delete(`${API_URL}/${directoryName}/files/${fileName}`, getAuthHeaders());
};

const deleteDirectory = (directoryName) => {
  return api.delete(`${API_URL}/${directoryName}`, getAuthHeaders());
};

const renameDirectory = (directoryName, newName) => {
  return api.put(`${API_URL}/${directoryName}/rename`, { newDirectoryName: newName }, getAuthHeaders());
};

const directoryService = { getDirectories, createDirectory, uploadFile, getUploadSasUrl, uploadFileDirectlyToBlob, getFilesInDirectory, deleteFile, deleteDirectory, renameDirectory };

export default directoryService;